export default __webpack_public_path__ + "static/media/qr-code.29b94eab.svg";